import styled from 'styled-components';
import { Text as TextLayoutComponent, Loader as LoaderComponent } from '@playbookux/playbook-web-core';

export const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  background-color: white;
  border: 1px solid #efefef;
  border-radius: 2px;
  margin-top: 10px;
`;

export const Loader = styled(LoaderComponent)`
  &&& {
    margin: auto;
  }
`;

export const ErrorMessage = styled(TextLayoutComponent)`
  font-size: 16px;
  text-align: center;
  && {
    margin: auto;
  };
`;
